<!--语音输入模板-->
<template>
  <div :class="[isToSpeakIng ? 'voive_wrapper IsToSpeak' : 'voive_wrapper']">
    <div class="hint_wrapper" v-if="isToSpeakIng">
      <div class="tip_wrapper">{{ tip }}</div>
      <div class="center">
        <!-- 正在说话显示语音波动 -->
        <div
          class="voide_fluctuate_wrapper"
          v-if="residueTime(touchTime) > 5 && !moveIn"
        >
          <img src="@/assets/img/audiospeek.gif" alt="删除语音" />
        </div>
        <!-- 剩余时间小于5秒进行提示 -->
        <div
          class="residue_wrapper"
          v-if="residueTime(touchTime) <= 5 && !moveIn"
        >
          <span class="number">{{ residueTime(touchTime) }}</span>
          <span class="data">秒后停止录音，直接发送</span>
        </div>
        <!-- 手指移入删除按钮，并且松开，删除语音，停止发送 -->
        <div class="del_wrapper" v-if="moveIn">
          <div class="icon_wrapper" id="del_icon_wrapper">
            <img src="@/assets/img/voiceDel.png" alt="删除语音" />
          </div>
        </div>
      </div>
      <div class="progress_bar_wrapper">
        <mt-progress
          :value="progressShow(touchTime)"
          :bar-height="5"
        ></mt-progress>
      </div>
    </div>
    <div class="operate_wrapper">
      <!-- <Button type="primary" @click="handlePlay">播放录音</Button>
         <Button type="primary" @click="handleupdown">下载</Button> -->
      <div
        class="inputCls"
        @touchstart.stop.prevent="touchstart"
        @touchmove.stop.prevent="touchmove"
        @touchend.stop.prevent="touchend"
        @click.stop.prevent="touchend"
      >
        {{ isToSpeakIng ? "松开 发送" : " 按住 说话" }}
      </div>
      <div class="button">
        <span @click="onChangeInputType(true)">
          <img src="@/assets/img/wordBtn.png" alt="切换页面输入方式" />
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import Recorder from "js-audio-recorder";
export default {
  name: "VoiceInputView",
  data() {
    return {
      btnWorld: "",
      touchTime: 0,
      times: null,
      audioTimes: null,
      tip: "上滑取消发送",
      moveIn: false,
      moveClientX: 0,
      moveClientY: 0,
      recorder: {},
      audioRippleData: [],
      numberTime: null,
      number: 100,
    };
  },
  created() {
    this.recorder = new Recorder({
      sampleBits: 16, // 采样位数，支持 8 或 16，默认是16
      sampleRate: 16000, // 采样率，支持 11025、16000、22050、24000、44100、48000，根据浏览器默认值，我的chrome是48000
      numChannels: 1, // 声道，支持 1 或 2， 默认是1
    });
  },
  computed: {
    ...mapState(["isToSpeakIng", "AutoplayPlayer"]),
    progressShow: function() {
      return function(value) {
        let percentage = (value / 30) * 100;
        return percentage;
      };
    },
    residueTime: function() {
      return function(value) {
        return 30 - Math.round(value);
      };
    },
  },
  methods: {
    ...mapMutations([
      "setToSpeakIng",
      "setChatLoading",
      "contactDisData",
      "setClearTimer",
    ]),
    ...mapActions([
      "sendAudiorecorderAsync",
      "sendAudiorecorder2Async",
      "setMaskDataAsync",
    ]),
    onChangeInputType: function() {
      this.$emit("onChangeInputType", false);
      this.setToSpeakIng(false);
    },
    touchstart: function(e) {
      let _this = this;
      // 长安开始说话了

      _this.numberTime = setInterval(() => {
        _this.number = _this.number + 10;
        // console.log("计时器数字为多少", _this.number);
        if (_this.number >= 120) {
          // 表示长按
          // console.log("表示长按");
          _this.clearIntervalNumberTime();

          _this.recorder.start(); // 开始录音
          // 开始录音
          _this.setToSpeakIng(true);
          // 清除自动请求的定时器
          _this.setClearTimer(true);
          //   点击就开始计时
          _this.times = setInterval(() => {
            if (_this.recorder.duration < 30) {
              _this.touchTime = _this.recorder.duration;
            } else {
              _this.sendrecorder();
              _this.setToSpeakIng(false);
              _this.touchTime = 0;
              clearInterval(_this.times);
              // 清除定时器，做对应的操作
            }
          }, 1);
        }
      }, 100);

      this.moveClientY = e.changedTouches[0].clientY;
      this.AutoplayPlayer.pause();
    },
    touchmove: function(e) {
      //   移动事件
      // 清除定时器
      // console.log("this.moveClientY===", this.moveClientY);
      // console.log(
      //   "e.changedTouches[0].clientY===",
      //   e.changedTouches[0].clientY
      // );
      // console.log(
      //   "this.moveClientY - e.changedTouches[0].clientY===",
      //   this.moveClientY - e.changedTouches[0].clientY
      // );
      if (this.moveClientY - e.changedTouches[0].clientY > 10) {
        this.moveIn = true;
        clearInterval(this.audioTimes);
        clearInterval(this.times);
        this.times = null;
        this.tip = "手指移入并松开，取消发送";
        this.moveClientX = e.changedTouches[0].clientX;
        this.moveClientY = e.changedTouches[0].clientY;
      }
      // this.moveClientY = e.changedTouches[0].clientY;
    },
    touchend: function() {
      let _this = this;
      // console.log("释放触发");
      clearInterval(this.times);
      this.times = null;

      // 进入开始说话
      this.setToSpeakIng(false);
      // 设置提示信息
      this.tip = "上滑取消发送";
      if (_this.number < 120) {
        // 没有开始录音
        // console.log("没有达到长按时间");
        _this.clearIntervalNumberTime();
      }

      if (this.recorder == null || this.recorder.duration === 0) {
        //  永远没有办法触发？
        // _this.setMaskDataAsync({ type: 10, text: "请长按按钮进行录音" });
        // setTimeout(() => {
        //   _this.setMaskDataAsync(null);
        // }, 1000);
        return false;
      } else {
        // console.log("触发的时间", this.recorder.duration);
        if (this.recorder.duration < 1) {
          // 小于1秒不发送，无论是否移动
          this.touchTime = 0;
          // clearInterval(this.times);
          // this.times = null;
          _this.setMaskDataAsync({
            type: 10,
            text: "请重新录制超过1秒的语音",
          });
          _this.recorder.stop();
          setTimeout(() => {
            _this.setMaskDataAsync(null);
          }, 1000);
        } else {
          // 触发时间大于1秒
          if (this.moveIn) {
            // 发送上滑动移动 去触发删除按钮
            let deldome = document.getElementById("del_icon_wrapper");
            let minX, minY, maxX, maxY;
            minX = deldome.getBoundingClientRect().left;
            minY = deldome.getBoundingClientRect().top;
            maxX = minX + deldome.offsetWidth;
            maxY = minY + deldome.offsetHeight;
            if (
              this.moveClientX >= minX &&
              this.moveClientX < maxX &&
              this.moveClientY >= minY &&
              this.moveClientY <= maxY
            ) {
               // 触发删除按钮不送
               console.log("触发删除按钮不送")
            }else{
              // 
               console.log("没有触发删除按钮，直接发送")
              this.sendrecorder();
            }
          }else{
            // 不移动
            this.sendrecorder();
          }
        }
      }

      //   松开事件
      // 清除定时器
    },
    sendrecorder: function() {
      let _this = this;
      // this.contactDisData([{ content: { right: true, tips: "" } }]);
      this.setChatLoading(true);

      var formData = new FormData();
      var blob = this.recorder.getPCMBlob(); //获取wav格式音频数据
      // l临时测试语音下载
      // this.handlePlay();
      //此处获取到blob对象后需要设置fileName满足当前项目上传需求，其它项目可直接传把blob作为file塞入formData
      var newbolb = new Blob([blob], { type: "audio/pcm" });
      var fileOfBlob = new File([newbolb], new Date().getTime() + ".pcm");

      formData.append("file", fileOfBlob);
      formData.append("type", "input");
      formData.append("questionData", "input");
      this.sendAudiorecorder2Async({
        payload: formData,
      }).then(() => {
        _this.setClearTimer(true);
      });
    },
    handlePlay() {
      // console.log("播放录音");
      this.recorder.play(); // 播放录音
    },
    handleupdown() {
      this.recorder.downloadPCM();
    },
    clearIntervalNumberTime() {
      // console.log("清除长按开启录音的计时器");
      clearInterval(this.numberTime);
      this.number = 100;
    },
  },
  handleDestroy() {
    console.log("销毁实例");
    this.recorder.destroy(); // 毁实例
    this.timer = null;
    clearInterval(this.numberTime);
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/less/common";
.voive_wrapper {
  //   height: 1rem;
  position: relative;
  .hint_wrapper {
    font-size: 0.32rem;
    text-align: center;
    color: #a3a3a3;

    .tip_wrapper {
      font-size: 0.32rem;
      text-align: center;
      color: #a3a3a3;
      &:hover {
        color: red;
      }
    }
    .center {
      width: 7.213333rem;
      height: 2rem;
      margin: 0.9rem auto 0.9rem;
      display: flex;
      justify-content: center;
      align-items: center;
      .voide_fluctuate_wrapper {
      }
      .residue_wrapper {
        .number {
          width: 1.2rem;
          height: 1.2rem;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          border-radius: 50%;
          background-color: @shadow-color;
          font-size: 0.693333rem;
          color: @primary-color;
          margin-right: 0.266667rem;
        }
        .data {
          font-size: 0.453333rem;
          color: #191919;
        }
      }
      .del_wrapper {
        .icon_wrapper {
          width: 2rem;
          height: 2rem;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: @shadow-color;
          img {
            width: 0.666667rem;
            height: 0.8rem;
          }
        }
      }
    }
  }
  .operate_wrapper {
    display: flex;
    justify-content: space-around;
    padding: 0.1rem 0;
    margin-top: 0.22rem;
    align-items: center;
    .inputCls {
      background-color: @shadow-color;
      width: 7.55rem;
      height: 1.17rem;
      padding: 0 0.43rem;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      outline: none;
      font-size: 0.37rem;
      border-radius: 0.6rem;
      border: 0.03rem solid #fff1f1;
      -webkit-appearance: none;
      line-height: 1.17rem;
      text-align: center;
      user-select: none;
      .del_wrapper {
        position: absolute;
        top: 0;
      }
      .del_wrapper:hover {
        color: red;
      }
    }

    .button {
      display: flex;
      justify-content: center;
      align-items: center;
      // .sendImg {
      //   width: 1.17rem;
      //   height: 1.17rem;
      // }
      align-items: center;
      width: 1rem;
      height: 1rem;
      border-radius: 50%;
      background-color: #e65757;
      font-size: 0.36rem;
      color: #fff;
      font-weight: 600;
    }
  }
}
.IsToSpeak {
  .hint_wrapper {
    font-size: 0.746667rem;
    color: #a3a3a3;
    padding-top: 0.04rem;
    padding-bottom: 0.166667rem;
  }

  .operate_wrapper {
    .inputCls {
      background-color: #ffb6b6;
    }
  }
}
</style>
<style lang="less">
@import "../../assets/less/common";
.progress_bar_wrapper {
  .mt-progress {
    .mt-progress-content {
      position: relative;
      .mt-progress-runway {
        background-color: #f0f0f0;
        border-radius: 0.106667rem;
      }
      .mt-progress-progress {
        border-radius: 0.106667rem;
        position: absolute;
        top: 0;
        background-color: @primary-color;
      }
    }
  }
}
</style>
